import { Link } from 'react-router-dom';

interface Town {
  id: string;
  name: string;
  slug: string;
}

interface TownNavBarProps {
  towns: Town[];
  currentTownSlug?: string;
  isPreview?: boolean;
  enableMarketValueReport?: boolean;
  enableMortgageInfo?: boolean;
  showBlogLink?: boolean;
  realtorFirstName?: string | null;
  themeId?: string;
}

export function TownNavBar({ 
  towns, 
  currentTownSlug, 
  isPreview = false,
  enableMarketValueReport = true,
  enableMortgageInfo = true,
  showBlogLink = true,
  realtorFirstName,
  themeId,
}: TownNavBarProps) {
  if (towns.length === 0) return null;

  const isSingleTown = towns.length === 1;
  const isLightTheme = themeId === 'light';
  
  const linkClass = isLightTheme 
    ? "text-xs font-medium whitespace-nowrap transition-colors text-foreground/70 hover:text-foreground uppercase tracking-wide"
    : "text-xs font-medium whitespace-nowrap transition-colors text-secondary-foreground/80 hover:text-secondary-foreground uppercase tracking-wide";
  const activeLinkClass = isLightTheme
    ? "text-xs font-medium whitespace-nowrap transition-colors text-foreground underline underline-offset-4 uppercase tracking-wide"
    : "text-xs font-medium whitespace-nowrap transition-colors text-secondary-foreground underline underline-offset-4 uppercase tracking-wide";

  return (
    <div className={`w-full ${isLightTheme ? 'bg-white border-b border-border' : 'bg-secondary'} ${isLightTheme ? 'text-foreground' : 'text-secondary-foreground'}`}>
      <div className="container py-2">
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
          {/* Show About link first when single town */}
          {isSingleTown && realtorFirstName && (
            <Link to="/" className={linkClass}>
              About {realtorFirstName}
            </Link>
          )}
          
          {towns.map((town) => (
            <Link
              key={town.id}
              to={`/${town.slug}${isPreview ? '?preview=true' : ''}`}
              className={currentTownSlug === town.slug ? activeLinkClass : linkClass}
            >
              {town.name}
            </Link>
          ))}
          
          {/* Show additional links when only 1 town */}
          {isSingleTown && (
            <>
              <Link to="/buyers" className={linkClass}>
                Buyers
              </Link>
              <Link to="/sellers" className={linkClass}>
                Sellers
              </Link>
              {enableMortgageInfo && (
                <Link to="/mortgages" className={linkClass}>
                  Mortgages
                </Link>
              )}
              {showBlogLink && (
                <Link to="/blog" className={linkClass}>
                  Blog
                </Link>
              )}
            </>
          )}
        </nav>
      </div>
    </div>
  );
}
